export const navLinks = [
  { id: "hot", label: "实时热榜" },
  { id: "live", label: "大瓜现场" },
  { id: "deep", label: "深度复盘" },
  { id: "glossary", label: "吃瓜词典" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];

export const feedCats = [
  { key: "all", label: "全部现场" },
  { key: "ent", label: "娱乐圈" },
  { key: "society", label: "社会热点" },
  { key: "tech", label: "科技圈" },
  { key: "sport", label: "体育" },
  { key: "finance", label: "财经" },
];

export const hotList = [
  { title: "年度话题剧《晚风来信》大结局开放收尾，全网弹幕刷屏", tag: "文娱", heat: 982 },
  { title: "某音乐综艺冷门歌手一曲翻唱爆红，原唱本人下场打call", tag: "文娱", heat: 876 },
  { title: "高校食堂'9.9元自助早餐'冲上热搜，学生晒图一片真香", tag: "民生", heat: 765 },
  { title: "折叠屏手机集体降价，轻薄大屏掀起换机小高潮", tag: "科技", heat: 698 },
  { title: "博物馆夜场开放引年轻人组团打卡，文物讲解被'挤爆'", tag: "文化", heat: 633 },
  { title: "中超补时绝杀瞬间，看台球迷手机光海刷成一片", tag: "体育", heat: 587 },
  { title: "黄金高位震荡，年轻人'攒金豆'理财悄悄走红", tag: "财经", heat: 545 },
  { title: "菜市场'代炒代做'服务走红，上班族拎菜即走不用开火", tag: "民生", heat: 502 },
  { title: "智能眼镜成新风口，AI随身助理开始'长在脸上'", tag: "科技", heat: 467 },
  { title: "县域小城旅游爆火，民宿周末预订量直接翻番", tag: "财经", heat: 421 },
];

export interface FeedItem {
  id: number;
  cat: string;
  catLabel: string;
  title: string;
  excerpt: string;
  time: string;
  views: string;
  comments: string;
  hot?: boolean;
  image: string;
  alt: string;
}

export const feedItems: FeedItem[] = [
  {
    id: 1,
    cat: "ent",
    catLabel: "娱乐圈",
    title: "《晚风来信》大结局留白被玩成梗，演员直播喊话观众别急",
    excerpt: "开放式结尾本来是想留余味，没想到被网友二创成各种'平行宇宙'剧本，主创索性下场一起玩。",
    time: "12 分钟前",
    views: "236万",
    comments: "8.4万",
    hot: true,
    image: "https://readdy.ai/api/search-image?query=Vibrant%20flat%20editorial%20illustration%20of%20a%20drama%20screenplay%20clapperboard%20and%20popcorn%20on%20a%20warm%20cream%20orange%20background%2C%20playful%20modern%20pop%20culture%20art%2C%20clean%20minimalist%20composition%2C%20high%20detail&width=800&height=600&seq=feed-ent-01&orientation=landscape",
    alt: "《晚风来信》大结局热议报道配图",
  },
  {
    id: 2,
    cat: "ent",
    catLabel: "娱乐圈",
    title: "实力唱将巡演加场官宣，票务平台首小时预约量刷新纪录",
    excerpt: "此前三场一票难求，官方连夜加开两场，二手市场黄牛行情应声回落，粉丝直呼'抢票的青春又回来了'。",
    time: "38 分钟前",
    views: "189万",
    comments: "6.2万",
    image: "https://readdy.ai/api/search-image?query=Flat%20vector%20illustration%20of%20a%20music%20concert%20stage%20with%20golden%20spotlights%20and%20a%20ticket%20in%20hand%20on%20warm%20amber%20background%2C%20energetic%20pop%20art%20style%2C%20minimalist%20modern%20design&width=800&height=600&seq=feed-ent-02&orientation=landscape",
    alt: "实力唱将巡演加场报道配图",
  },
  {
    id: 3,
    cat: "society",
    catLabel: "社会热点",
    title: "高校食堂'9.9元自助早餐'排队两小时，学生直呼幸福感拉满",
    excerpt: "豆浆油条加蒸点敞开吃，一顿还不到十块钱。校长回应：亏一点没关系，孩子们吃饱吃好最重要。",
    time: "1 小时前",
    views: "412万",
    comments: "15.3万",
    image: "https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20campus%20cafeteria%20breakfast%20with%20soy%20milk%20steamed%20buns%20and%20fried%20sticks%20on%20warm%20cream%20background%2C%20friendly%20lifestyle%20editorial%20art%2C%20minimalist%20modern%20style&width=800&height=600&seq=feed-soc-01&orientation=landscape",
    alt: "高校9.9元自助早餐报道配图",
  },
  {
    id: 4,
    cat: "society",
    catLabel: "社会热点",
    title: "菜市场'代炒代做'成新宠：下班拎菜进去，热乎晚饭带走",
    excerpt: "按斤收加工费，厨师现场爆炒。打工人感叹：这波是'中央厨房'开进了我家楼下菜市场。",
    time: "2 小时前",
    views: "287万",
    comments: "9.6万",
    image: "https://readdy.ai/api/search-image?query=Cheerful%20flat%20illustration%20of%20a%20lively%20wet%20market%20stall%20with%20chef%20stir%20frying%20in%20a%20wok%20and%20fresh%20vegetables%2C%20warm%20orange%20tones%2C%20editorial%20lifestyle%20art%2C%20modern%20minimal&width=800&height=600&seq=feed-soc-02&orientation=landscape",
    alt: "菜市场代炒代做服务报道配图",
  },
  {
    id: 5,
    cat: "tech",
    catLabel: "科技圈",
    title: "折叠屏价格下探到三千档，轻薄大屏成换机新思路",
    excerpt: "几大厂商同时发力供应链，铰链工艺成熟后成本骤降，'折叠不贵'的时代似乎真的来了。",
    time: "3 小时前",
    views: "156万",
    comments: "4.1万",
    image: "https://readdy.ai/api/search-image?query=Sleek%20flat%20illustration%20of%20a%20foldable%20smartphone%20half%20unfolded%20glowing%20with%20UI%20icons%20on%20a%20soft%20peach%20and%20cream%20background%2C%20modern%20tech%20editorial%20art%2C%20minimalist&width=800&height=600&seq=feed-tech-01&orientation=landscape",
    alt: "折叠屏手机降价报道配图",
  },
  {
    id: 6,
    cat: "tech",
    catLabel: "科技圈",
    title: "智能眼镜'长在脸上'成新风口，AI随身助理快步入场",
    excerpt: "从AR导航到实时翻译，小屏幕正在接管大需求。厂商称下一代产品将主打'看得见的AI'。",
    time: "4 小时前",
    views: "134万",
    comments: "3.8万",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20flat%20illustration%20of%20smart%20glasses%20displaying%20floating%20AR%20hologram%20elements%20on%20warm%20amber%20gradient%20background%2C%20modern%20tech%20pop%20art%2C%20clean%20minimalist&width=800&height=600&seq=feed-tech-02&orientation=landscape",
    alt: "智能眼镜新风口报道配图",
  },
  {
    id: 7,
    cat: "sport",
    catLabel: "体育",
    title: "中超补时绝杀那一刻：三万观众手机光海亮成银河",
    excerpt: "终场哨响前的那脚弧线，把整座体育场的呐喊都点燃了。赛后球员绕场致谢，看台久久不愿散场。",
    time: "5 小时前",
    views: "221万",
    comments: "7.7万",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20flat%20illustration%20of%20a%20football%20stadium%20at%20night%20with%20crowd%20phone%20lights%20like%20stars%20and%20a%20soccer%20ball%20in%20flight%2C%20warm%20orange%20and%20cream%20tones%2C%20energetic%20editorial%20sport%20art&width=800&height=600&seq=feed-sport-01&orientation=landscape",
    alt: "中超补时绝杀报道配图",
  },
  {
    id: 8,
    cat: "finance",
    catLabel: "财经",
    title: "年轻人开始'攒金豆'：每月一克，把焦虑换成实打实的底气",
    excerpt: "相比大额金条，一两克的金豆门槛更低、仪式感更强。理财师提醒：攒金可以，别把'薅羊毛'当成了稳赚。",
    time: "6 小时前",
    views: "178万",
    comments: "5.5万",
    image: "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20of%20golden%20gold%20beans%20and%20coins%20scattered%20beside%20a%20glass%20jar%20on%20a%20soft%20amber%20cream%20background%2C%20finance%20savings%20editorial%20art%2C%20modern%20minimal&width=800&height=600&seq=feed-fin-01&orientation=landscape",
    alt: "年轻人攒金豆理财报道配图",
  },
  {
    id: 9,
    cat: "finance",
    catLabel: "财经",
    title: "县域小城旅游跑出加速度，一碗地道小吃也能带火一座城",
    excerpt: "不追大城市的热闹，越来越多游客把假期'押注'在小县城。民宿房东：周末预订已经排到两月后。",
    time: "7 小时前",
    views: "203万",
    comments: "6.9万",
    image: "https://readdy.ai/api/search-image?query=Cozy%20flat%20illustration%20of%20a%20quaint%20small%20county%20town%20street%20with%20food%20stalls%20and%20travellers%20on%20a%20warm%20peach%20background%2C%20travel%20editorial%20art%2C%20lively%20modern%20minimalist&width=800&height=600&seq=feed-fin-02&orientation=landscape",
    alt: "县域小城旅游爆火报道配图",
  },
];

export interface DeepArticle {
  id: string;
  category: string;
  title: string;
  dek: string;
  author: string;
  date: string;
  readMinutes: number;
  image: string;
  alt: string;
  blocks: { heading?: string; paragraph?: string }[];
}

export const featuredDeep: DeepArticle = {
  id: "deep-01",
  category: "深度复盘",
  title: "一场热搜的'前世今生'：从首发爆料到全网二创，吃瓜到底在吃什么",
  dek: "我们扒了近期几条刷屏事件的完整时间线，试着回答那个朴素的问题——大家排队围观，究竟是为了真相，还是为了那份'和大家一起知道'的感觉。",
  author: "编辑部·追瓜小组",
  date: "2026-09-05",
  readMinutes: 8,
  image: "https://readdy.ai/api/search-image?query=Artistic%20flat%20illustration%20of%20a%20magnifying%20glass%20above%20scattered%20newspaper%20clips%20and%20speech%20bubbles%20on%20a%20warm%20cream%20and%20coral%20background%2C%20storytelling%20editorial%20art%2C%20modern%20pop%20illustration&width=1200&height=760&seq=deep-hero-01&orientation=landscape",
  alt: "热搜事件来龙去脉深度复盘专题配图",
  blocks: [
    { heading: "第一幕：一颗'瓜'是怎么被人看见的", paragraph: "几乎所有刷屏事件，起点都极小。可能是某条匿名留言、一段路透视频，或某位圈内人的一句玩笑。真正的分水岭，往往是有人把它'翻译'成了大家都能共鸣的一句话，转发量这才开始指数级上涨。" },
    { heading: "第二幕：围观也是一种参与", paragraph: "当话题冲上热榜，评论区就成了第二现场。有人整理时间线，有人补全背景，有人玩梗造段子——所谓'吃瓜群众'，其实一直在用自己的方式参与叙事，把零散信息拼成一个完整的故事。" },
    { heading: "第三幕：反转与求证，才是常态", paragraph: "热度越高，噪音越大。首发截图未必完整，聊天记录也可能断章取义。成熟的围观，是把'求锤'留给自己，把'下结论'放一放。多方信源交叉验证，往往比抢首发更接近真相。" },
    { heading: "第四幕：一场热搜终会降温", paragraph: "再热的话题，几天后也会被新的瓜覆盖。但这并不意味着它毫无意义——一次认真的围观，帮我们练就了辨别信息、共情他人、克制表达的能力。这，才是吃瓜真正的'后劲'。" },
  ],
};

export const relatedDeep = [
  { title: "辟谣'全流程'拆解：一条假消息要过几道关才能上热搜", time: "4.2万阅读", blurb: "从零星流言到被广泛转载，假消息的传播有迹可循。我们拆解谣言发酵的关键节点，聊聊为什么'转发前先查证'比想象中更重要。" },
  { title: "为什么越离谱的瓜，大家越爱看？聊聊'幸存者偏差'", time: "3.6万阅读", blurb: "围观行为背后藏着认知心理。越是猎奇反常的内容越容易刷屏，这篇带你理解信息传播里那个有趣的偏差。" },
  { title: "从'实锤'到'反转'：网络时代的信息素养课", time: "5.1万阅读", blurb: "信息越喧嚣，越考验分辨力。我们结合近期案例，总结一套面对热搜时自查信息真假的小方法，吃瓜也能更清醒。" },
  { title: "聊天记录截图能当证据吗？吃瓜也要懂点法律常识", time: "2.9万阅读", blurb: "吃瓜吃到法律边缘怎么办？这篇简单聊聊截图的证明力、言论边界与隐私问题，让你围观得更安心。" },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  { q: "看吃瓜多久更新一次热点内容？", a: "我们的编辑团队全天候跟踪各大平台话题趋势，热榜与现场信息流基本做到小时级滚动更新。遇到突发大瓜，会在核实后第一时间补发，确保你看到的尽量是'热乎的'。" },
  { q: "信息来源可靠吗？怎么判断爆料真假？", a: "看吃瓜坚持'先求证、再发布'的原则。常规内容以多家正规媒体与官方回应为主要信源，并明确标注'已确认''网传''待求证'等状态。也建议你在阅读时保持思辨，以官方权威信息为准。" },
  { q: "想追某条瓜的完整来龙去脉，应该看哪里？", a: "在'深度复盘'栏目中，我们会为热议事件梳理完整时间线与关键节点，把'从哪开始、中间怎么变、现在到哪一步'一次讲清楚，帮你快速补齐错过的前情提要。" },
  { q: "如何订阅吃瓜快讯，第一时间收到新瓜提醒？", a: "在页面底部填写邮箱并点击订阅即可。新瓜、专题更新与热点复盘发布后，我们会以邮件形式第一时间推送给你，让你不必天天蹲守也能跟上节奏。" },
  { q: "看到疑似不实或侵权内容，应该怎么办？", a: "可通过页面底部的联系邮箱反馈。我们会在核实后对相关内容进行标注、修正或下架处理，并为信息纠错提供及时通道。" },
  { q: "可以投稿爆料或洽谈合作吗？", a: "当然可以。欢迎通过页面底部的联系方式投稿或咨询合作，提供线索时请尽量附上时间与来源，便于我们快速核实与跟进。" },
];

export const glossaryTerms = [
  { term: "前排吃瓜", def: "第一时间赶到话题现场，抢占热评前列的围观行为。" },
  { term: "瓜主", def: "掌握某事件核心信息、主动放出消息的人。" },
  { term: "实锤", def: "确凿到难以辩驳的证据，也称'石锤'。" },
  { term: "反转", def: "事件走向与最初传言相反，真相出现大转弯。" },
  { term: "辟谣", def: "针对不实信息发布的澄清与说明。" },
  { term: "塌房", def: "粉丝发现偶像人设崩塌、滤镜破碎的瞬间。" },
  { term: "体面", def: "对某一方妥善、克制处理方式的高度概括。" },
  { term: "二创", def: "以原作内容为基础进行的二次创作。" },
  { term: "圈内人", def: "掌握一手行业信息、常在评论区现身说法的人。" },
  { term: "站队", def: "在争议中明确表达自己支持某一方。" },
];

export const testimonials = [
  {
    name: "橘子汽水",
    role: "通勤追热点",
    quote: "以前刷一天才能拼出全貌，现在来看吃瓜一个'深度复盘'就补齐了前情。再也不怕同事聊瓜的时候接不上话了。",
  },
  {
    name: "隔壁老张",
    role: "多年围观群众",
    quote: "很喜欢它的克制，该标注'网传'就标'网传'，不会为了流量乱下结论。吃瓜也要吃得明明白白。",
  },
  {
    name: "深夜码字员",
    role: "自由撰稿人",
    quote: "追时间线、找背景资料基本一站搞定，省下大把时间。订阅推送也很准时，新瓜一个不漏。",
  },
];

export const stats = [
  { num: "1200+", label: "全网热点事件收录" },
  { num: "86", label: "条深度时间线复盘" },
  { num: "300万+", label: "累计围观人次" },
  { num: "98%", label: "内容核实后再发布" },
];

export const heroBigTitle = ["全网最热的瓜", "都在这一口"];